export default __webpack_public_path__ + "assets/images/e3f9b3d9e75e8448328ae1aebb1bfd57.jpg";